import auth from '@/Middlewares/auth.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'

export const emailPartRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('email-parts', {
      list: () => import(/* webpackChunkName: "admin" */ './Pages/List.vue'),
    })
      .except(['create', 'edit'])
      .permissions({
        list: 'email-parts.view',
      })
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
